import http from "@/utils/request"

export default {
	city: {
		list: async function (data = {}) {
			return await http.get("city/list", data);
		},
		add: async function (data = {}) {
			return await http.post("city/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("city/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("city/del", data);
		},
		option: async function (data = {}) {
			return await http.get("city/option", data);
		},
	},
	store: {
		list: async function (data = {}) {
			return await http.get("store/list", data);
		},
		add: async function (data = {}) {
			return await http.post("store/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("store/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("store/del", data);
		},
		option: async function (data = {}) {
			return await http.get("store/option", data);
		},
		area: async function (data = {}) {
			return await http.get("store/area", data);
		},
	},
	train: {
		list: async function (data = {}) {
			return await http.get("train/list", data);
		},
		add: async function (data = {}) {
			return await http.post("train/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("train/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("train/del", data);
		},
		option: async function (data = {}) {
			return await http.get("train/option", data);
		},
		info: async function (data = {}) {
			return await http.get("train/info", data);
		},
		time: async function (data = {}) {
			return await http.get("train/time", data);
		},
	},
	user: {
		list: async function (data = {}) {
			return await http.get("user/list", data);
		},
	},
	user_times: {
		list: async function (data = {}) {
			return await http.get("user/times/list", data);
		},
		give: async function (data = {}) {
			return await http.post("user/times/give", data);
		},
		del: async function (data = {}) {
			return await http.delete("user/times/del", data);
		},
	},
	user_money: {
		list: async function (data = {}) {
			return await http.get("user/money/list", data);
		},
		give: async function (data = {}) {
			return await http.post("user/money/give", data);
		},
		del: async function (data = {}) {
			return await http.delete("user/money/del", data);
		},
	},
	user_time: {
		change: async function (data = {}) {
			return await http.post("user/time/change", data);
		},
	},
	time: {
		list: async function (data = {}) {
			return await http.get("time/list", data);
		},
		add: async function (data = {}) {
			return await http.post("time/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("time/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("time/del", data);
		},
	},
}
